/* eslint-disable */
import React, { useState, useEffect } from "react";
import axios from "axios";
import { useDispatch } from "react-redux";
import { useSelector } from "react-redux";
import Modal from "react-modal";
import { Spin } from "antd";
import { Search, Check, X } from "lucide-react";
import { serverTimestamp } from "firebase/firestore";
import Swal from "sweetalert2";
import withReactContent from "sweetalert2-react-content";
import { useNavigate } from "react-router-dom";
import { set } from "date-fns";
import { useTranslation } from "react-i18next";
import useIsDark from "../../utils/isDark";
Modal.setAppElement("#root");

const TemplateLoadingModal = ({ isOpen }) => {
  const { t } = useTranslation();
  const isDark = useIsDark();
  const customLoadingStyles = {
    content: {
      top: "50%",
      left: "50%",
      right: "auto",
      bottom: "auto",
      marginRight: "-50%",
      transform: "translate(-50%, -50%)",
      width: "500px",
      maxWidth: "90%",
      borderRadius: "12px",
      padding: "0",
      border: `1px solid ${isDark ? "#3c3a3d" : "#e5e7eb"}`,
      boxShadow:
        "0 4px 6px -1px rgba(0, 0, 0, 0.1), 0 2px 4px -1px rgba(0, 0, 0, 0.06)",
      maxHeight: "90vh",
      overflow: "hidden",
    },
    overlay: {
      backgroundColor: "rgba(0, 0, 0, 0.7)",
      zIndex: 999999,
    },
  };

  return (
    <Modal
      isOpen={isOpen}
      style={customLoadingStyles}
      contentLabel="جاري التحميل"
      shouldCloseOnOverlayClick={false}
      shouldCloseOnEsc={false}
    >
      <div className="bg-[#181919] backdrop-blur-sm rounded-2xl border border-[#3c3a3d] shadow-2xl p-8">
        <h3 className="text-2xl font-bold text-[#9e68ba] mb-6 text-center">
          {t("foorAi.modal2.creatingLandingPage")}
        </h3>

        {/* Robot AI Animation */}
        <div className="flex justify-center mb-6">
          <div className="w-32 h-32 flex items-center justify-center">
            <div className="relative">
              <img
                src="https://media2.giphy.com/media/v1.Y2lkPTc5MGI3NjExY24xYjlydjBjNWtlNHVzemJna2ZrMzg5Y2ZnMnZybHVsMTJ6eHJzYSZlcD12MV9pbnRlcm5hbF9naWZfYnlfaWQmY3Q9Zw/brnrokmYFFT0Znl5hQ/giphy.gif"
                alt={t("ui.aiWorking")}
                className="w-24 h-24 object-contain"
              />

              {/* Particules animées */}
              <div className="absolute -top-2 -right-2 w-3 h-3 bg-[#9e68ba] rounded-full animate-ping opacity-60"></div>
              <div
                className="absolute -top-1 -left-3 w-2 h-2 bg-purple-400 rounded-full animate-ping opacity-60"
                style={{ animationDelay: "0.5s" }}
              ></div>
              <div
                className="absolute -bottom-2 -right-1 w-2 h-2 bg-[#9e68ba] rounded-full animate-ping opacity-60"
                style={{ animationDelay: "1s" }}
              ></div>
              <div
                className="absolute top-1/2 -left-4 w-1.5 h-1.5 bg-purple-300 rounded-full animate-ping opacity-60"
                style={{ animationDelay: "1.5s" }}
              ></div>
            </div>
          </div>
        </div>

        {/* Texte avec points animés */}
        <div className="bg-[#141414] rounded-xl p-4 mb-6 border border-[#3c3a3d]">
          <div className="text-center">
            <span className="text-lg font-semibold text-[#9e68ba]">
              {t("foorAi.modal2.aiWorking")}
              <span className="inline-flex ml-1">
                <span className="animate-pulse">.</span>
                <span
                  className="animate-pulse"
                  style={{ animationDelay: "0.3s" }}
                >
                  .
                </span>
                <span
                  className="animate-pulse"
                  style={{ animationDelay: "0.6s" }}
                >
                  .
                </span>
              </span>
            </span>
          </div>
        </div>

        {/* Info message */}
        <div className="bg-[#141414] rounded-xl p-4 border border-[#3c3a3d]">
          <div className="text-center text-sm text-blue-400">
            <span className="font-medium">
              {t("foorAi.modal2.infoMessage")}
            </span>
          </div>
        </div>
      </div>
    </Modal>
  );
};

const ProductExportModal = ({ isOpen, onClose }) => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const [link, setLink] = useState("");
  const [isLoading, setIsLoading] = useState(false);
  const [error, setError] = useState(null);
  const products = useSelector((state) => state.ProductsReducer);
  const account = useSelector((state) => state.AccountReducer);
  const store = useSelector((state) => state.StoreReducer);
  const [selectedProducts, setSelectedProducts] = useState([]);
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [hasFetched, setHasFetched] = useState(false);
  const [storeType, setStoreType] = useState("");
  const [manualSelectVisible, setManualSelectVisible] = useState(false);
  const [templates, setTemplates] = useState([]);
  const [openAiResponse, setOpenAiResponse] = useState(null);
  const [step, setStep] = useState(0);
  const [selectedTemplateId, setSelectedTemplateId] = useState(null);
  const [visibleImageId, setVisibleImageId] = useState(null);
  const { t, i18n } = useTranslation();

  // New states for template loading
  const [isTemplateLoading, setIsTemplateLoading] = useState(false);
  const [selectedImageUrl, setSelectedImageUrl] = useState(null);
  const isDark = useIsDark();
  // Custom styles for the main modal
  const customStyles = {
    content: {
      top: "50%",
      left: "50%",
      right: "auto",
      bottom: "auto",
      marginRight: "-50%",
      transform: "translate(-50%, -50%)",
      width: "800px",
      maxWidth: "90%",
      borderRadius: "12px",
      padding: "0",
      border: `1px solid ${isDark ? "#3c3a3d" : "#e5e7eb"}`,
      boxShadow:
        "0 4px 6px -1px rgba(0, 0, 0, 0.1), 0 2px 4px -1px rgba(0, 0, 0, 0.06)",
      maxHeight: "90vh",
      overflow: "hidden",
    },
    overlay: {
      backgroundColor: "rgba(0, 0, 0, 0.5)",
      zIndex: 1000,
    },
  };

  const toggleImage = (imageUrl) => {
    setSelectedImageUrl(imageUrl);
  };

  const closeModal = () => setSelectedImageUrl(null);
  // Reset state when modal is opened
  useEffect(() => {
    if (isOpen) {
      setLink("");
      setError(null);
      //setProducts([]);
      setSelectedProducts([]);
      setIsLoading(false);
      setIsSubmitting(false);
      setHasFetched(false);
      setStoreType("");
      setManualSelectVisible(false);
      setIsTemplateLoading(false);
    }
  }, [isOpen]);

  // Handle selection of a product
  const handleSelectProduct = (product) => {
    setSelectedProducts([product]); // نخزن Object مباشرة
  };
  // Handle submit action
  // Fonction utilitaire pour choisir un élément aléatoirement
  const getRandomTemplate = (templates) => {
    if (!templates || templates.length === 0) {
      return null;
    }
    const randomIndex = Math.floor(Math.random() * templates.length);
    return templates[randomIndex];
  };

  // Fonction pour convertir hex en rgba
  const hexToRgba = (hex, alpha = 1) => {
    // Supprimer le # si présent
    hex = hex.replace("#", "");

    // Convertir en RGB

    const r = parseInt(hex.substring(0, 2), 16);
    const g = parseInt(hex.substring(2, 4), 16);
    const b = parseInt(hex.substring(4, 6), 16);

    return `rgba(${r}, ${g}, ${b}, ${alpha})`;
  };

  // Fonction pour convertir hex en rgba avec alpha 0
  const hexToRgba0 = (hex) => {
    return hexToRgba(hex, 0);
  };

  // Fonction pour mettre à jour les liens d'images
  const updateImageLinks = (templateJsonStr, gallery) => {
    let templateJson;
    try {
      templateJson = JSON.parse(templateJsonStr.json);
    } catch (error) {
      console.error("Error parsing JSON:", error);
      return null;
    }

    let imageIndex = 0;

    // قائمة الصور التي سيتم تحديثها فقط
    const imagesToUpdate = [
      "https://utfs.io/f/229fd226-e475-468b-b587-e73b53f248c6-qa59oi.png",
      "https://utfs.io/f/2b4cdf19-a1a4-4914-9f61-3b474d608b72-qzexc.png",
      "https://utfs.io/f/5c5478d9-df8e-4262-bea4-f89eb225e619-wgvzfu.webp",
      "https://utfs.io/f/b13aae1e-0728-46e8-9ed0-79abb338d7b6-qzey7.png",
      "https://utfs.io/f/b13aae1e-0728-46e8-9ed0-79abb338d7b6-.png",
      "https://utfs.io/f/9dcd5a57-a98b-4121-b407-c0f90c84bd8e-gpmij7.webp",
      "https://utfs.io/f/c42f65c5-1085-4e86-89a1-357c927cce85-8pw4ey.webp",
      "https://utfs.io/f/a1ece8a1-fc1a-4327-abb3-491ebd3b3811-gpmij7.webp",
      "https://utfs.io/f/8188b0ee-203e-4213-8ae8-969940dbe89f-20sa0v.webp",
      "https://utfs.io/f/2cd580e7-45ee-4ddb-afee-76e841eef722-3yoe1c.webp",
      "https://utfs.io/f/2a066e46-34b1-41fd-ba28-097a869ef429-3jp8kn.webp",
      "https://utfs.io/f/a1ece8a1-fc1a-4327-abb3-491ebd3b3811-gpmij7.webp",
      "https://utfs.io/f/2cd580e7-45ee-4ddb-afee-76e841eef722-3yoe1c.webp",
    ];
    // console.log(templateJson.objects);
    if (Array.isArray(templateJson.objects)) {
      templateJson.objects.forEach((obj, index) => {
        if (obj.type === "image" && imagesToUpdate.includes(obj.src)) {
          if (gallery[imageIndex]) {
            const newSrc = `${gallery[imageIndex]}`;
            obj.src = newSrc;
            imageIndex = (imageIndex + 1) % gallery.length;
          } else {
            console.warn(`No image found for index ${index}`);
          }
        }
      });
    } else {
      console.error("templateJson.objects is not an array");
      return null;
    }

    return templateJson;
  };

  const updateText = (templateJson, aiRaw, storeData, productData) => {
    if (!templateJson || typeof templateJson !== "object") return null;

    let responseData;
    try {
      const clean = cleanJsonFromLLM(aiRaw);
      responseData = JSON.parse(clean);
    } catch (e) {
      console.error("Error parsing AI response:", e, aiRaw);
      return null;
    }

    if (!Array.isArray(templateJson.objects)) {
      console.error("templateJson.objects is not an array");
      return null;
    }

    const hexToRgba = (hex, alpha = 1) => {
      hex = String(hex || "").replace("#", "");
      if (hex.length !== 6) return `rgba(12, 192, 223, ${alpha})`;
      const r = parseInt(hex.slice(0, 2), 16);
      const g = parseInt(hex.slice(2, 4), 16);
      const b = parseInt(hex.slice(4, 6), 16);
      return `rgba(${r}, ${g}, ${b}, ${alpha})`;
    };

    const hexToRgba0 = (hex) => hexToRgba(hex, 0);

    templateJson.objects.forEach((obj) => {
      // استبدال الألوان حسب ألوان المتجر
      if (obj.fill === "rgba(12, 192, 223, 1)" && storeData?.color1) {
        obj.fill = hexToRgba(storeData.color1);
      }
      if (obj.stroke === "rgba(12, 192, 223, 1)" && storeData?.color1) {
        obj.stroke = hexToRgba(storeData.color1);
      }
      if (obj.fill?.colorStops?.length > 1 && storeData?.color1) {
        if (obj.fill.colorStops[0].color === "rgba(12, 192, 223, 1)") {
          obj.fill.colorStops[0].color = hexToRgba(storeData.color1);
        }
        if (obj.fill.colorStops[1].color === "rgba(12, 192, 223, 0)") {
          obj.fill.colorStops[1].color = hexToRgba0(storeData.color1);
        }
      }

      if (obj.type === "textbox") {
        switch (obj.text) {
          case "text1":
            obj.text =
              responseData?.text1 || "حوّل تجربة المشاهدة إلى تجربة مميزة";
            break;
          case "thebestchoice":
            obj.text = responseData?.thebestchoice || "الخيــــــــــار الأمثل";
            break;
          case "text2":
            obj.text = responseData?.text2 || "لأداء يتجاوز الحدود";
            break;
          case "text3":
            obj.text = responseData?.text3 || "لماذا هذا المنتج مناسب لك؟";
            break;
          case "text4":
            obj.text = responseData?.text4 || "تجربة مشاهدة استثنائية";
            break;
          case "text5":
            obj.text = responseData?.text5 || "تنظيم مثالي لملابسك";
            break;
          case "text6":
            obj.text = responseData?.text6 || "الحل الأمثل لتنظيم منزلك بذكاء";
            break;
          case "text7":
            obj.text =
              responseData?.text7 || "املأ الاستمارة الآن للحصول على العرض";
            break;

          // الخصائص
          case "properties.[0].title":
          case "proper1":
            obj.text = responseData?.properties?.[0]?.title || "جهاز متطور";
            break;
          case "properties.[0].description":
            obj.text =
              responseData?.properties?.[0]?.description ||
              "تقنية حديثة لضمان أفضل جودة.";
            break;

          case "properties.[1].title":
          case "proper2":
            obj.text = responseData?.properties?.[1]?.title || "أوقات ترفيهية";
            break;
          case "properties.[1].description":
            obj.text =
              responseData?.properties?.[1]?.description ||
              "تنظيم وتجربة متكاملة.";
            break;

          case "properties.[2].title":
          case "proper3":
            obj.text = responseData?.properties?.[2]?.title || "خيارات أكثر";
            break;
          case "properties.[2].description":
            obj.text =
              responseData?.properties?.[2]?.description ||
              "سهولة وصول وتفاعل ممتاز.";
            break;

          // الميزات
          case "features.[0].title":
            obj.text = responseData?.features?.[0]?.title || "جودة عالية";
            break;
          case "features.[0].description":
            obj.text =
              responseData?.features?.[0]?.description ||
              "صورة واضحة وصوت نقي.";
            break;

          case "features.[1].title":
            obj.text = responseData?.features?.[1]?.title || "سهولة الاستخدام";
            break;
          case "features.[1].description":
            obj.text =
              responseData?.features?.[1]?.description || "واجهة بسيطة وسلسة.";
            break;

          case "features.[2].title":
            obj.text = responseData?.features?.[2]?.title || "اتصال سريع";
            break;
          case "features.[2].description":
            obj.text =
              responseData?.features?.[2]?.description || "تدفق دون انقطاع.";
            break;

          case "features.[3].title":
            obj.text = responseData?.features?.[3]?.title || "تنوع البرامج";
            break;
          case "features.[3].description":
            obj.text =
              responseData?.features?.[3]?.description ||
              "تطبيقات وبرامج كثيرة.";
            break;

          // السعر Placeholder باسم "1200"
          case "1200":
            obj.text = String(
              productData?.product?.price ?? productData?.price ?? "1200"
            );
            break;

          default:
            break;
        }
      }
    });

    return templateJson;
  };

  // Fonction handleSubmit modifiée
  const handleSubmit = async () => {
    console.log("selectedProducts", selectedProducts);
    if (selectedProducts.length === 0) {
      setError(t("digitalSections.messages.form.warningText"));
      return;
    }

    setIsSubmitting(true);

    try {
      const response = await axios.get(
        "https://foorai.foorweb.store/api/projects/templates?page=1&limit=10"
      );
      const templatesJson = response.data.data;

      const projectIds = [
        "f69bb7c1-bae0-40f9-b233-deae9ff783c5",
        "8f30aa02-c6d6-4be3-9fb1-4e6311498608",
        "d0bdc94d-a083-4eb7-900c-f999180b59bc",
        "ed063cd6-1e9f-4f79-af62-6c7b72c7290c",
        "4954cb90-4add-4665-b84a-e6052b969dbb",
      ];
      const filteredTemplates = templatesJson.filter((template) =>
        projectIds.includes(template.id)
      );
      console.log(filteredTemplates);

      setTemplates(filteredTemplates);
      setStep(1);
    } catch (e) {
      console.error("Erreur:", e);
      alert(e.message || e);
    } finally {
      setIsSubmitting(false);
    }
  };

  const cleanJsonFromLLM = (raw) => {
    if (!raw) return "";
    let txt = String(raw).trim();

    // احذف code fences لو وجدت
    if (txt.startsWith("```")) {
      txt = txt.replace(/```json|```/g, "").trim();
    }
    // التقط أول كائن JSON سليم
    const m = txt.match(/\{[\s\S]*\}$/m);
    if (m) txt = m[0];

    return txt;
  };

  const fetchOpenAiResponse = async (productName) => {
    try {
      const response = await fetch("https://backend.foorweb.store/api/chatgpt/canvaAi", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({ productName }),
      });

      const text = await response.text(); // نقرأ الرد كنص خام

      if (!response.ok) {
        console.error("Server error:", text);
        throw new Error("Server error");
      }

      // نحاول تحويله لـ JSON
      let data;
      try {
        data = JSON.parse(text);
      } catch {
        console.warn("⚠️ الرد مش JSON نقي:", text);
        // نحاول نلقط JSON داخل النص فقط
        const match = text.match(/\{[\s\S]*\}/);
        data = match ? JSON.parse(match[0]) : { result: text };
      }

      const content = data?.result || "";
      return cleanJsonFromLLM(content);
    } catch (e) {
      console.error("fetchOpenAiResponse error:", e);
      throw e;
    }
  };

  // Updated template confirmation handler with AI loading
  const handleTemplateConfirm = async () => {
    try {
      setIsTemplateLoading(true);

      const selectedTemplate = templates.find(
        (t) => t.id === selectedTemplateId
      );
      if (!selectedTemplate) throw new Error("Aucun template disponible");

      await new Promise((r) => setTimeout(r, 400));

      const gallery = selectedProducts[0].gallery;
      let updatedTemplate = updateImageLinks(selectedTemplate, gallery);
      if (!updatedTemplate)
        throw new Error("Erreur lors de la mise à jour des images");

      await new Promise((r) => setTimeout(r, 300));

      const storeData = store;
      const productData = selectedProducts[0];

      // ✅ خذ الرد وترجِعه فورًا
      const aiRaw = await fetchOpenAiResponse(productData.name);

      await new Promise((r) => setTimeout(r, 300));

      updatedTemplate = updateText(
        updatedTemplate,
        aiRaw,
        storeData,
        productData
      );
      if (!updatedTemplate)
        throw new Error("Erreur lors de la mise à jour des textes");

      // حفظ المشروع
      const res = await fetch("https://foorai.foorweb.store/api/sendi", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({
          name: `${productData.name} صفحة هبوط لمنتج`,
          json: JSON.stringify(updatedTemplate),
          width: 900,
          height: 1200,
          userFoorweb: account?.user,
          thumbnailUrl: productData.gallery?.[0] || productData.image,
          urlProduct: productData.url,
          isPro: false,
          userId: "bc98963e-2f96-4536-a9c4-97ad0ab4667d",
        }),
      });
      const data = await res.json();

      await new Promise((r) => setTimeout(r, 200));

      navigate(`/landing-page/editor`, {
        state: { data, user: account?.user },
      });
    } catch (error) {
      console.error(error);
      setIsTemplateLoading(false);
      Swal.fire(t("error"), error.message || "حدث خطأ", "error");
    }
  };

  return (
    <>
      {/* Main Modal */}
      <Modal
        isOpen={isOpen && !isTemplateLoading}
        onRequestClose={onClose}
        style={customStyles}
        contentLabel={t("foorAi.importProducts.title")}
      >
        <div className="py-4 px-6 relative dark:!bg-[#181819] dark:!border-[#3c3a3d]">
          <div className="flex items-center dark:!bg-[#181819] justify-between mb-4 pb-2 border-b  dark:!border-[#3c3a3d]">
            <h2 className="text-[#9e65bb] font-bold text-xl flex-grow">
              {t("foorAi.importProducts.title")}
            </h2>
            <button
              onClick={() => {
                onClose();
                setSelectedProducts([]);
                setStep(0);
              }}
              className="p-2 hover:bg-gray-100 dark:hover:bg-[#2a2a2b] rounded-full transition-colors"
            >
              <X className="text-[#9e65bb]" size={22} />
            </button>
          </div>

          {error && (
            <div className="bg-red-50 dark:bg-red-900/20 border border-red-200  dark:!border-red-500 text-red-700 dark:text-red-400 px-5 py-4 rounded-lg mb-5 flex items-center shadow-sm">
              <span className="mr-2 font-medium">{error}</span>
            </div>
          )}

          {step == 0 && products.length > 0 && (
            <div className="bg-white dark:!bg-[#181819] rounded-lg border dark:!border-[#181819]">
              <div className="flex justify-between items-center mb-4">
                <h3 className="text-lg font-semibold text-[#9e65bb]">
                  {t("foorAi.importProducts.step0.foundProducts", {
                    count: products.length,
                  })}
                </h3>
              </div>

              <div
                className="max-h-96 overflow-y-auto mb-5 pr-2"
                style={{
                  scrollbarWidth: "thin",
                  scrollbarColor: "#d8b4fe #f5f5f5",
                }}
              >
                <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
                  {products.map((product, index) => {
                    return (
                      <div
                        key={index}
                        onClick={() => handleSelectProduct(product)}
                        className={`border rounded-lg overflow-hidden flex cursor-pointer transition-all hover:shadow-md  dark:!border-[#3c3a3d] dark:hover:border-[#9b59bf] ${
                          selectedProducts.includes(index)
                            ? "border-[#9b59bf] bg-purple-50 dark:!bg-[#2a2a2b] shadow-sm"
                            : "border-gray-200 hover:border-[#9b59bf]  dark:!border-[#3c3a3d]"
                        }`}
                      >
                        <div className="flex-shrink-0 w-24 h-24 bg-gray-100 dark:!bg-[#2a2a2b]">
                          {product.image && (
                            <img
                              src={product.image}
                              alt={product.name}
                              className="w-full h-full object-cover"
                            />
                          )}
                        </div>
                        <div className="flex-grow p-3 flex flex-col justify-between">
                          <div>
                            <h4 className="font-medium text-sm line-clamp-2 mb-1 dark:text-gray-200">
                              {product.name}
                            </h4>
                            <div className="flex items-center text-sm gap-2">
                              <span className="font-bold text-[#9e65bb]">
                                {product.price} {t("currency")}
                              </span>
                              {product.comparePrice && (
                                <span className="text-gray-400 line-through">
                                  {product.comparePrice} {t("currency")}
                                </span>
                              )}
                            </div>
                          </div>
                        </div>
                        <div className="flex items-center p-3">
                          <div
                            className={`h-6 w-6 rounded-full border flex items-center justify-center transition-colors ${
                              selectedProducts.includes(product)
                                ? "bg-[#9b59bf] border-[#9b59bf]"
                                : "border-gray-300  dark:!border-[#3c3a3d]"
                            }`}
                          >
                            {selectedProducts.includes(product) && (
                              <Check size={14} className="text-white" />
                            )}
                          </div>
                        </div>
                      </div>
                    );
                  })}
                </div>
              </div>

              <div className="flex justify-end gap-3 mt-6 border-t pt-3  dark:!border-[#3c3a3d]">
                <button
                  onClick={() => {
                    setStep(0);
                    onClose();
                    setSelectedProducts([]);
                  }}
                  className="px-5 py-2.5 border border-gray-300  dark:!border-[#3c3a3d] text-gray-700 dark:text-gray-300 rounded-lg hover:bg-gray-50 dark:hover:bg-[#2a2a2b] transition-colors font-medium"
                >
                  {t("foorAi.importProducts.step0.buttons.cancel")}
                </button>
                <button
                  onClick={handleSubmit}
                  disabled={selectedProducts.length === 0 || isSubmitting}
                  className={`px-5 py-2.5 rounded-lg text-white font-medium flex items-center shadow-sm ${
                    selectedProducts.length === 0 || isSubmitting
                      ? "bg-[#9b59bf] opacity-70 cursor-not-allowed"
                      : "bg-[#9b59bf] hover:bg-[#814a9f] transition-colors"
                  }`}
                >
                  {isSubmitting ? (
                    <>
                      <Spin size="small" />
                      <span className="mr-2">
                        {t("foorAi.importProducts.step0.buttons.creating")}
                      </span>
                    </>
                  ) : (
                    <>
                      <Check size={18} className="ml-2" />
                      <span>
                        {t("foorAi.importProducts.step0.buttons.create")}
                      </span>
                    </>
                  )}
                </button>
              </div>
            </div>
          )}

          {step === 1 && templates.length > 0 && (
            <div className="bg-white dark:!bg-[#181819] rounded-lg border  dark:!border-[#181819]">
              <h3 className="text-lg font-semibold text-[#9e65bb] mb-4">
                {t("foorAi.importProducts.step1.chooseTemplate", {
                  count: templates.length,
                })}
              </h3>

              <div className="grid grid-cols-1 md:grid-cols-2 gap-4 max-h-96 overflow-y-auto pr-2">
                {templates.map((template, index) => (
                  <div
                    key={template.id}
                    onClick={() => setSelectedTemplateId(template.id)}
                    className={`border rounded-lg p-4 cursor-pointer transition-all hover:shadow-md  dark:!border-[#3c3a3d] ${
                      selectedTemplateId === template.id
                        ? "border-[#9b59bf] bg-purple-50 dark:!bg-[#2a2a2b] shadow-sm"
                        : "border-gray-200 hover:border-[#9b59bf]  dark:!border-[#3c3a3d]"
                    }`}
                  >
                    <div className="flex justify-between items-start">
                      <div>
                        <div className="font-bold text-sm text-[#9e65bb] mb-1">
                          {t("foorAi.importProducts.step1.templateNumber", {
                            number: index + 1,
                          })}
                        </div>
                      </div>

                      <button
                        onClick={(e) => {
                          e.stopPropagation();
                          toggleImage(template.thumbnailUrl); // image en grand
                        }}
                        className="text-gray-500 hover:text-[#9b59bf] transition-colors ml-2"
                      >
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          className="w-5 h-5"
                          fill="none"
                          viewBox="0 0 24 24"
                          stroke="currentColor"
                        >
                          <path
                            strokeLinecap="round"
                            strokeLinejoin="round"
                            strokeWidth={2}
                            d="M15 12a3 3 0 11-6 0 3 3 0 016 0z"
                          />
                          <path
                            strokeLinecap="round"
                            strokeLinejoin="round"
                            strokeWidth={2}
                            d="M2.458 12C3.732 7.943 7.523 5 12 5c4.477 0 8.268 2.943 9.542 7-1.274 4.057-5.065 7-9.542 7-4.477 0-8.268-2.943-9.542-7z"
                          />
                        </svg>
                      </button>
                    </div>
                  </div>
                ))}
              </div>

              <div className="flex justify-end gap-3 mt-6 border-t pt-3  dark:!border-[#3c3a3d]">
                <button
                  onClick={() => {
                    setStep(0);
                    onClose();
                    setSelectedProducts([]);
                  }}
                  className="px-5 py-2.5 border border-gray-300  dark:!border-[#3c3a3d] text-gray-700 dark:text-gray-300 rounded-lg hover:bg-gray-50 dark:hover:bg-[#2a2a2b] transition-colors font-medium"
                >
                  {t("foorAi.importProducts.step1.buttons.cancel")}
                </button>
                <button
                  disabled={!selectedTemplateId}
                  onClick={handleTemplateConfirm}
                  className={`px-5 py-2.5 rounded-lg text-white font-medium flex items-center shadow-sm ${
                    !selectedTemplateId
                      ? "bg-[#9b59bf] opacity-70 cursor-not-allowed"
                      : "bg-[#9b59bf] hover:bg-[#814a9f] transition-colors"
                  }`}
                >
                  <Check size={18} className="ml-2" />
                  <span>
                    {t("foorAi.importProducts.step1.buttons.confirm")}
                  </span>
                </button>
              </div>
            </div>
          )}
        </div>
      </Modal>

      {selectedImageUrl && (
        <div
          className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center"
          onClick={closeModal}
          style={{ zIndex: 9999 }}
        >
          <div
            className="bg-white rounded-lg p-2 max-w-3xl w-full max-h-[90vh] overflow-auto"
            onClick={(e) => e.stopPropagation()}
          >
            <img
              src={"/e3ad61ba-d4c7-489e-b7b9-34a163f09cad.png"}
              alt={t("foorAi.importProducts.imagePreview.alt")}
              className="w-full h-auto rounded shadow-lg"
            />
          </div>
        </div>
      )}

      {/* Separate Loading Modal */}
      <TemplateLoadingModal isOpen={isTemplateLoading} />
    </>
  );
};

export default ProductExportModal;
